module.exports = __webpack_public_path__ + "media/images/USA-groom-image1-bdc2b8592a251882082f69060506671e.jpg";